import { useForm } from "@tanstack/react-form"

import { FormField } from "@/components/FormField"

interface BasicInformationFormProps {
  user: {
    firstName?: string | null
    lastName?: string | null
    email?: string | null
    username?: string | null
  } | null
}

export function BasicInformationForm({ user }: BasicInformationFormProps) {
  const form = useForm({
    defaultValues: {
      firstName: user?.firstName ?? "",
      lastName: user?.lastName ?? "",
      email: user?.email ?? "",
      username: user?.username ?? "",
    },
  })

  return (
    <div className="tw-space-y-4">
      <h2 className="tw-text-lg tw-font-semibold tw-text-gray-900">
        Basic Information
      </h2>

      <div className="tw-flex tw-flex-col tw-gap-3 md:tw-w-1/2 [&_label]:!tw-text-sm">
        <form.Field
          name="firstName"
          children={(field) => (
            <FormField field={field} label="First Name" readOnly={true} />
          )}
        />
        <form.Field
          name="lastName"
          children={(field) => (
            <FormField field={field} label="Last Name" readOnly={true} />
          )}
        />
        <form.Field
          name="email"
          children={(field) => (
            <FormField
              field={field}
              label="Email"
              type="email"
              readOnly={true}
            />
          )}
        />
        <form.Field
          name="username"
          children={(field) => (
            <FormField field={field} label="Username" readOnly={true} />
          )}
        />
      </div>
    </div>
  )
}
